import {
	createStore,
	createContainer,
	createStateHook,
	createHook,
	type BoundActions,
	type ContainerComponent,
	type HookFunction,
	type HookStateFunction,
	type StoreActionApi,
} from 'react-sweet-state';

type PTV2StoreContainerProps = {
	teamType?: string;
	subAnchor?: string;
	personalSpaceKey: string;
	isTemplateListDismissed?: boolean;
	personalizationHeuristic?: string;
	onboardingPeriodDay?: number;
	isXflow?: boolean;
	source?: string;
};

const PTV2Store = createStore({
	initialState: {
		teamType: '',
		subAnchor: '',
		personalSpaceKey: '',
		isTemplateListDismissed: true,
		personalizationHeuristic: '',
		onboardingPeriodDay: 0,
		isXflow: false,
		source: '',
	},
	actions: {
		setIsTemplateListDismissed:
			(
				isTemplateListDismissed: boolean,
			): (({
				setState,
			}: StoreActionApi<{
				teamType: string;
				subAnchor: string;
				personalSpaceKey: string;
				isTemplateListDismissed: boolean;
				personalizationHeuristic: string;
				onboardingPeriodDay: number;
				isXflow: boolean;
				source: string;
			}>) => void) =>
			({ setState }) => {
				setState({ isTemplateListDismissed });
			},
	},
	name: 'PTV2Store',
});

export const usePTV2State: HookStateFunction<
	{
		teamType: string;
		subAnchor: string;
		personalSpaceKey: string;
		isTemplateListDismissed: boolean;
		personalizationHeuristic: string;
		onboardingPeriodDay: number;
		isXflow: boolean;
		source: string;
	},
	void
> = createStateHook(PTV2Store);

export const usePTV2Store: HookFunction<
	{
		teamType: string;
		subAnchor: string;
		personalSpaceKey: string;
		isTemplateListDismissed: boolean;
		personalizationHeuristic: string;
		onboardingPeriodDay: number;
		isXflow: boolean;
		source: string;
	},
	BoundActions<
		{
			teamType: string;
			subAnchor: string;
			personalSpaceKey: string;
			isTemplateListDismissed: boolean;
			personalizationHeuristic: string;
			onboardingPeriodDay: number;
			isXflow: boolean;
			source: string;
		},
		{
			setIsTemplateListDismissed: (isTemplateListDismissed: boolean) => ({
				setState,
			}: StoreActionApi<{
				teamType: string;
				subAnchor: string;
				personalSpaceKey: string;
				isTemplateListDismissed: boolean;
				personalizationHeuristic: string;
				onboardingPeriodDay: number;
				isXflow: boolean;
				source: string;
			}>) => void;
		}
	>,
	void
> = createHook(PTV2Store);

export const PTV2StoreContainer: ContainerComponent<PTV2StoreContainerProps> = createContainer(
	PTV2Store,
	{
		onInit:
			() =>
			(
				{ setState },
				{
					teamType,
					subAnchor,
					personalSpaceKey,
					isTemplateListDismissed,
					personalizationHeuristic,
					onboardingPeriodDay,
					isXflow,
					source,
				},
			) => {
				setState({
					teamType,
					subAnchor,
					personalSpaceKey,
					isTemplateListDismissed,
					personalizationHeuristic,
					onboardingPeriodDay,
					isXflow,
					source,
				});
			},
	},
);
